import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
  scmAuthApiRef,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  identityApiRef,
  analyticsApiRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import {
  catalogImportApiRef,
  CatalogImportClient,
} from '@backstage/plugin-catalog-import';
import { MyOwnClient } from './lib/myClient';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { CustomAnalyticsApi } from './apis/CustomAnalyticsApi';
import { CatalogImportApiWithErrorDetails } from './apis/CatalogImportApiWithErrorDetails';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory(techRadarApiRef, new MyOwnClient()),

  createApiFactory({
    api: analyticsApiRef,
    deps: {
      configApi: configApiRef,
      identityApi: identityApiRef,
    },
    factory: ({ configApi, identityApi }) =>
      new CustomAnalyticsApi(configApi, identityApi) as any,
  }),

  createApiFactory({
    api: catalogImportApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      scmAuthApi: scmAuthApiRef,
      fetchApi: fetchApiRef,
      scmIntegrationsApi: scmIntegrationsApiRef,
      catalogApi: catalogApiRef,
      configApi: configApiRef,
    },
    // scmIntegrationsApiRef resolves to @backstage/integration v2 while
    // plugin-catalog-import is still typed against v1, so the registry needs a
    // cast even though the client only uses members common to both.
    factory: ({ scmIntegrationsApi, ...rest }) =>
      new CatalogImportApiWithErrorDetails(
        new CatalogImportClient({
          ...rest,
          scmIntegrationsApi: scmIntegrationsApi as any,
        }),
      ),
  }),
];
